import methods from './methods'
import props from './props'

export default {
  methods,
  props,

  resourcePath: '/v1/professional/schedules/'
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/components/absent/resources/index.js